import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logScreenView } from '../services/analyticsService';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let screenName = location.pathname;
    if (screenName === '/') screenName = '/home';
    
    // Simplify dynamic routes for cleaner analytics
    if (screenName.startsWith('/cruise/')) screenName = '/cruise_details';
    if (screenName.startsWith('/edit-cruise/')) screenName = '/edit_cruise';
    if (screenName.startsWith('/ship/')) screenName = '/ship_details';
    if (screenName.startsWith('/ship-class/')) screenName = '/ship_class';
    if (screenName.startsWith('/friend/')) screenName = '/friend_cruises';
    if (screenName.startsWith('/post-cruise-details/')) screenName = '/post_cruise_details';
    
    logScreenView(screenName);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
